// Mock data for WebCare IT Solution website

export const companyInfo = {
  name: "WebCare IT Solution",
  tagline: "Innovative Software Solutions Since 2008",
  established: 2008,
  domain: "webcareitsolution.in",
  natureMessage: "Technology in Harmony with Nature - Building sustainable digital solutions for a greener tomorrow"
};

export const products = [
  {
    id: 1,
    name: "Paying Guest Software",
    description: "Complete PG management system with room allocation, billing, tenant tracking, and automated rent collection.",
    features: ["Room Management", "Billing & Invoicing", "Tenant Portal", "Reports & Analytics"]
  },
  {
    id: 2,
    name: "Accounting Software",
    description: "Comprehensive accounting solution for businesses with GST compliance, invoicing, and financial reporting.",
    features: ["GST Compliance", "Invoice Management", "Financial Reports", "Expense Tracking"]
  },
  {
    id: 3,
    name: "Transport (Fleet) Management",
    description: "Advanced fleet management system for vehicle tracking, maintenance scheduling, and route optimization.",
    features: ["GPS Tracking", "Maintenance Alerts", "Route Planning", "Driver Management"]
  },
  {
    id: 4,
    name: "Apartment Management Software",
    description: "Streamline society operations with visitor management, billing, complaints, and maintenance tracking.",
    features: ["Visitor Management", "Maintenance Bills", "Complaint Tracking", "Notice Board"]
  },
  {
    id: 5,
    name: "Doctor Prescription Management",
    description: "Digital prescription system for clinics with patient records, appointment scheduling, and medicine database.",
    features: ["Patient Records", "Digital Prescriptions", "Appointment Booking", "Medicine Database"]
  },
  {
    id: 6,
    name: "Cable Billing Software",
    description: "Cable operator management system with subscriber billing, package management, and payment tracking.",
    features: ["Subscriber Management", "Package Plans", "Automated Billing", "Payment Gateway"]
  },
  {
    id: 7,
    name: "Ward Digital Service Portal",
    description: "Digital Ward Management System with WhatsApp-based complaint registration, resident certificate processing, and real-time admin dashboard for efficient civic service delivery.",
    features: ["WhatsApp Complaint Management", "Online Resident Certificate", "Admin Dashboard", "Real-time Tracking"],
    htmlPage: "/product-one.html"
  }
];

export const services = [
  {
    id: 1,
    title: "Custom Application Development",
    description: "Tailored software applications designed to meet your specific business requirements and workflows."
  },
  {
    id: 2,
    title: "Web Portal Development",
    description: "Secure, scalable web portals for enterprises, e-commerce, and customer engagement platforms."
  },
  {
    id: 3,
    title: "Website Design & Development",
    description: "Responsive, SEO-optimized websites that deliver exceptional user experiences across all devices."
  },
  {
    id: 4,
    title: "Standalone Software Solutions",
    description: "Desktop applications for Windows and cross-platform solutions for business automation."
  },
  {
    id: 5,
    title: "Mobile Application Development",
    description: "Native and cross-platform mobile apps for iOS and Android with seamless user experience and performance."
  },
  {
    id: 6,
    title: "AI Agent Development",
    description: "Intelligent AI-powered agents and chatbots that automate tasks, provide customer support, and enhance business operations."
  }
];

export const portfolio = [
  {
    id: 1,
    title: "Multi-Location PG Chain Management",
    client: "PG Hospitality Group",
    description: "Implemented centralized management system for 15+ PG locations with 500+ rooms",
    year: "2023"
  },
  {
    id: 2,
    title: "Hospital Management System",
    client: "City Care Hospital",
    description: "Complete digital transformation with OPD, IPD, pharmacy, and lab management",
    year: "2022"
  },
  {
    id: 3,
    title: "Logistics Fleet Optimization",
    client: "Express Transport Ltd",
    description: "Fleet tracking and route optimization system for 100+ vehicles",
    year: "2023"
  },
  {
    id: 4,
    title: "Residential Society Portal",
    client: "Green Valley Apartments",
    description: "Smart society management for 500+ flats with mobile app integration",
    year: "2022"
  }
];

export const team = [
  {
    id: 1,
    name: "Vijay Rathod",
    role: "Founder & CEO",
    bio: "Visionary leader with 23 years of experience in software development and nature conservation"
  },
  {
    id: 2,
    name: "Saurav Kukkar",
    role: "Chief Technology Officer",
    bio: "Expert in enterprise architecture and sustainable technology solutions"
  },
  {
    id: 3,
    name: "Shradha Rathod",
    role: "Product Development Head",
    bio: "Specialized in creating innovative software products for diverse industries"
  },
  {
    id: 4,
    name: "Gajanan Bhayekar",
    role: "Client Relations Manager",
    bio: "Dedicated to ensuring client success and long-term partnerships"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Mr. Suresh Me***",
    company: "Mehta Accounting Services",
    feedback: "WebCare's accounting software has transformed our practice. The GST compliance features are excellent!",
    rating: 5
  },
  {
    id: 2,
    name: "Dr. Anjali V****",
    company: "Verma Clinic",
    feedback: "The prescription management system is intuitive and has made our clinic paperless. Highly recommended!",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Vikram S****",
    company: "Singh Transport Corporation",
    feedback: "Fleet management software has reduced our operational costs by 30%. Outstanding support team!",
    rating: 5
  },
  {
    id: 4,
    name: "Mrs. Kavita J*****",
    company: "Sunrise Apartments",
    feedback: "Society management has never been easier. Residents love the transparency and digital payments.",
    rating: 5
  }
];

export const stats = [
  { label: "Years of Excellence", value: "17+" },
  { label: "Products Developed", value: "6" },
  { label: "Happy Clients", value: "500+" },
  { label: "Projects Delivered", value: "600+" }
];
